<template>
    <div class="wraps" v-if="msgShow">
      <div class="bottom-control">
        <div class="title">
          <span>消息通知</span>
          <i class="iconfont icon-guanbi" @click="close"></i>
        </div>
        <div class="content" @click="gotoMsgDetail">
          <div class="little-title">{{ messageHead }}</div>
          <img class="img" v-if="pictureUrl" :src="pictureUrl"/>
          <div class="info" v-else>{{ synopsis }}</div>
        </div>
      </div>
    </div>
</template>

<script>
export default {
  props: {
    msgShow: {
      type: Boolean,
      default: false,
    },
    messageHead: {
      type: String,
      default: '',
    }, // 通知标题
    synopsis: {
      type: String,
      default: '',
    }, // 通知简介
    pictureUrl: {
      type: String,
      default: '',
    },
    messageNotifyId: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {}
  },
  methods: {
    close() {
      this.$emit('update:msgShow', false);
      console.log(this.messageNotifyId);
      if (this.messageNotifyId !== 0) {
        this.getMsgDetail();
      }
    },
    gotoMsgDetail() {
      if (this.messageNotifyId) {
        this.close(this.messageNotifyId);
        const { href } = this.$router.resolve({name: 'messageDetail', query: { id: this.messageNotifyId } });
        window.open(href, '_blank');
        // this.$router.push({name: 'messageDetail', query:{ id: this.messageNotifyId }});
        // this.close(this.messageNotifyId);
      }
    },
    // 查看消息详情
    getMsgDetail() {
      this.$api.global.getMessage({
        id: this.messageNotifyId,
        isNotPoped: 1, // 是否关闭消息弹窗
      }).then(() => {
      });
    },
  },
};

</script>

<style lang="scss" scoped>
.wraps::after {
  content: '';
  height: 278px;
  display: block;
  width: 362px;
}
.bottom-control {
  position: fixed;
  width: 362px;
  right: 0px;
  bottom: 0px;
  height: 278px;
  box-sizing: border-box;
  overflow: auto;
  background: white;
  box-shadow:0px -2px 8px 1px rgba(196,196,196,0.2);
  z-index: 301;
}
.title {
  height:40px;
  line-height: 40px;
  color: #fff;
  font-size: 16px;
  background: #3F97FF;
  display: flex;
  padding: 0 14px;
  justify-content: space-between;
  .icon-guanbi {
    cursor:pointer;
  }
}
.content {
  padding: 16px 16px 0 16px;
  cursor:pointer;
  font-size: 18px;
  color: #333;
  height: 220px;
  .little-title {
    font-weight:bold;
    line-height: 1.5;
  }
  .info {
    font-size: 14px;
    margin-top: 16px;
    line-height: 1.5;
  }
  .img {
    width: 330px;
    height: 140px;
    margin-top: 10px;
  }
}
</style>
